import axios from 'axios';
import _ from 'lodash';
import { STORY_SERVICE_API } from './constants';

/**
 * Fetch one page of stories for a discussion. `params` carries limit, cursor,
 * start/end, sort and matched/reviewed — all handled server-side. Resolves to
 * { stories, nextCursor }, where nextCursor is null once the page is the last.
 */
const fetchStories = (platform, discussionId, params) => axios
  .get(`${STORY_SERVICE_API}/${platform}/discussion/${discussionId}/stories`, { params })
  .then(res => ({
    stories: _.get(res, 'data.stories', []),
    nextCursor: _.get(res, 'data.nextCursor', null),
  }));

export default fetchStories;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/stories-api.js
 **/